import { render, staticRenderFns } from "./GeofencePerson.vue?vue&type=template&id=030bfe9e&scoped=true"
import script from "./GeofencePerson.vue?vue&type=script&lang=js"
export * from "./GeofencePerson.vue?vue&type=script&lang=js"
import style0 from "./GeofencePerson.vue?vue&type=style&index=0&id=030bfe9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bfe9e",
  null
  
)

export default component.exports